const LOCALSTORAGE_PRODUCT_KEY = "cachedProduct";
const LOCALSTORAGE_ORDER_KEY = "cachedOrder";

export default class PreviousOrderHelper {

  static setCachedProductKey(cachedProductKey) {
    const value = JSON.stringify(cachedProductKey);
    localStorage.setItem(LOCALSTORAGE_PRODUCT_KEY, value);
  }

  static getCachedProductKey() {
    const value = localStorage.getItem(LOCALSTORAGE_PRODUCT_KEY);
    const parsedValue = JSON.parse(value);

    return parsedValue;
  }

  static setCachedOrder(cachedOrder) {
    const value = JSON.stringify(cachedOrder);
    localStorage.setItem(LOCALSTORAGE_ORDER_KEY, value);
  }

  static getCachedOrder() {
    const value = localStorage.getItem(LOCALSTORAGE_ORDER_KEY);
    const parsedValue = JSON.parse(value);

    return parsedValue;
  }
}
